/* ============
 * Field list
 * ============
 *
 * List of fields .
 */

import Vue from 'vue';
import prodFieldTransformer from './../../transformers/productForm';

const success = ({ data }, resolve) => {
  const fields = prodFieldTransformer.fetchCollection(data.data);

  resolve(fields);
};

const failed = (error, reject) => reject(error);

// Display cities related to a country.
export default (id, name) => (
  new Promise((resolve, reject) => {
    const query = name ? `forms/${id}?name=${name}` : `forms/${id}`;
    Vue.$http.get(query)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/form/fields.js